import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Select, Space } from 'antd';
import React, { useState } from 'react';

export const TransferSearch = ({
  handleSearch,
  direction,
  filterOptions,
  onFilterChange,
  filterValue,
}: {
  handleSearch: (direction: 'left' | 'right', value: string) => void;
  direction: 'left' | 'right';
  filterOptions?: { label: string; value: string }[];
  onFilterChange?: (value: string) => void;
  filterValue?: string;
}): JSX.Element => {
  const [value, setValue] = useState('');

  const onSearch = (): void => {
    handleSearch(direction, value);
  };

  return (
    <div style={{ padding: '8px' }}>
      <Space>
        <Space.Compact>
          <Input
            style={{ width: '200px' }}
            placeholder="enter search term"
            value={value}
            onChange={e => setValue(e.target.value)}
            onPressEnter={onSearch}
          />
          <Button icon={<SearchOutlined />} onClick={onSearch} />
        </Space.Compact>
        {filterOptions && onFilterChange && (
          <Select
            style={{ width: 150 }}
            value={filterValue}
            onChange={onFilterChange}
            options={filterOptions}
          />
        )}
      </Space>
    </div>
  );
};
